export const SCORE_SETTINGS_ID = '911a39d3-9567-4676-9bd5-8a063c5a96cc';
